import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLTableColElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableColElement
 */
export default class HTMLTableColElement extends HTMLElement {}
